import { useEffect, useRef, useState } from 'react';

// Mozgás-segédek az A · Élő vezérlő arculathoz. A csökkentett mozgást kérő böngészőben azonnal a végállapot látszik.
export const reducedMotion = () => typeof matchMedia !== 'undefined' && matchMedia('(prefers-reduced-motion: reduce)').matches;

// Felpörgő szám: betöltéskor (és értékváltáskor) a régi értékről az újra fut.
export function CountUp({ value, decimals = 0, suffix = '' }: { value: number; decimals?: number; suffix?: string }) {
  const [shown, setShown] = useState(reducedMotion() ? value : 0);
  const from = useRef(0);
  useEffect(() => {
    if (reducedMotion()) { setShown(value); return undefined; }
    const start = from.current; const t0 = performance.now(); let raf = 0;
    const step = (t: number) => { const k = Math.min(1, (t - t0) / 1100); const e = 1 - Math.pow(1 - k, 4); setShown(start + (value - start) * e); if (k < 1) raf = requestAnimationFrame(step); else from.current = value; };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [value]);
  return <>{shown.toFixed(decimals).replace('.', ',')}{suffix}</>;
}

// Dekódoló felirat: a szöveg véletlen karakterekből áll össze, amikor megjelenik vagy megváltozik.
const CHARS = 'ABCDEFGHIJKLMNOPRSTUVZ0123456789#/_';
export function Decode({ text, duration = 650 }: { text: string; duration?: number }) {
  const [shown, setShown] = useState(text);
  useEffect(() => {
    if (reducedMotion()) { setShown(text); return undefined; }
    const t0 = performance.now(); let raf = 0;
    const step = (t: number) => {
      const k = Math.min(1, (t - t0) / duration); const n = Math.floor(text.length * k);
      setShown(text.slice(0, n) + [...text.slice(n)].map((c) => (c === ' ' ? ' ' : CHARS[Math.floor(Math.random() * CHARS.length)])).join(''));
      if (k < 1) raf = requestAnimationFrame(step); else setShown(text);
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [text, duration]);
  return <>{shown}</>;
}

// Kis görbe (pl. KPI-csempén): egy sorozat, a címe nevezi meg.
export function Spark({ values, className = '' }: { values: number[]; className?: string }) {
  if (values.length < 2) return null;
  const max = Math.max(...values, 1);
  const pts = values.map((v, i) => `${(i / (values.length - 1)) * 120},${32 - (v / max) * 30 - 1}`).join(' ');
  return <svg className={`a-spark ${className}`} viewBox="0 0 120 32" preserveAspectRatio="none" aria-hidden="true"><polyline points={pts} fill="none" stroke="currentColor" strokeWidth="2" vectorEffect="non-scaling-stroke" /></svg>;
}

// Óra a fejlécben (másodpercre).
export function useClock(): string {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => { const t = window.setInterval(() => setNow(new Date()), 1000); return () => clearInterval(t); }, []);
  return now.toLocaleTimeString('hu-HU');
}
